module.exports = __webpack_public_path__ + "assets/img/paypal.949c41c1.png";